//Include Both Helper File with needed methods

import {
  
  getTotalInvestmentWithdrawal,
    
} from "../../../helpers/fakebackend_helper";



import { createAsyncThunk } from "@reduxjs/toolkit";


export const home_investment_withdrawalThunk = createAsyncThunk("home_investment_withdrawalThunk", async ({  token }, { rejectWithValue } ) => {
  try {
    const response = await getTotalInvestmentWithdrawal( token);
    return response;
  } catch (error) {
    // Properly pass the error structure to the reducer
    return rejectWithValue({
      code: error.data?.code || error.code,
      message: error.message,
      data: error.data
    });
  }
});










